import { render, staticRenderFns } from "./ColorChooser.vue?vue&type=template&id=39951a9e&scoped=true"
import script from "./ColorChooser.vue?vue&type=script&lang=js"
export * from "./ColorChooser.vue?vue&type=script&lang=js"
import style0 from "./ColorChooser.vue?vue&type=style&index=0&id=39951a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39951a9e",
  null
  
)

export default component.exports